import React, { useEffect, useState } from "react";
import { httpService } from "../../../../services/httpService.service";

import SearchIcon from "./../../../../Assets/svg/searchIcon.svg";
import Preview from "../../planning/VisitBoard/TableView/modals/Preview";
import Edit from "../ReportingList/modals/Edit";
import rejectIcon from "../../../../Assets/svg/cancel-remove-cross-close.svg";
import approveIcon from "../../../../Assets/svg/check-validation-sucess.svg";
import markAsCompletedIcon from "../../../../Assets/svg/check-square-form-validation-checkmark-success-box-square-tick.svg";
import ConfirmModal from "../../../components/confirmModal/ConfirmModal";
import Done from "../../../../Assets/svg/done.svg";
import exclamationMark from "../../../../Assets/svg/exclamationMark.svg";
import previewIcon from "./../../../../Assets/svg/table-action-preview.svg";
import { useFilePreview } from "../../completed/ReportingList/Download";
import {
  formatDate,
  formatDateAndTime,
} from "../../../../services/helpFunctions/formatDateAndTime";
import { Input, Spin, Table, Tooltip } from "antd";
import FacilityTag from "../../../components/FacilityTag/FacilityTag";
import { REPORTING_DEFAULT_COLUMNS } from "../../../components/SiteVisitColumns/siteVisitColumnOrder";
import { useSiteVisitColumns } from "../../../components/SiteVisitColumns/useSiteVisitColumns";
const Approved = ({ loading, setLoading, setMessage }) => {
  const { previewFiles } = useFilePreview();
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 576);
  const [selectedSiteVisit, setSelectedSiteVisit] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [approvedSiteVisitCards, setApprovedSiteVisitCards] = useState([]);
  const [searchQueryForApproval, setSearchQueryForApproval] = useState("");
  const [debouncedQueryForApproval, setDebouncedQueryForApproval] = useState(
    searchQueryForApproval
  );
  const [paginationForApproval, setPaginationForApproval] = useState({
    pageSize: 10,
    pageNumber: 1,
    total: 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 576);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSearchForApproval = (e) => {
    setSearchQueryForApproval(e.target.value);
    setPaginationForApproval((prevPagination) => ({
      ...prevPagination,
      pageNumber: 1,
    }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQueryForApproval(searchQueryForApproval);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQueryForApproval]);

  const fetchApprovedSiteVisits = () => {
    const projectId = localStorage.getItem("currentProjectID");

    const params = {
      ProjectId: projectId,
      Search: debouncedQueryForApproval,
      pageSize: paginationForApproval.pageSize,
      pageNumber: paginationForApproval.pageNumber,
      SiteVisitStatus: [2, 3, 4, 5],
      ApprovalStatus: 2,
    };

    const expandArrayParams = (params) => {
      const expanded = [];
      for (const [key, value] of Object.entries(params)) {
        if (Array.isArray(value)) {
          value.forEach((v) => expanded.push([key, v]));
        } else if (
          value !== undefined &&
          value !== null &&
          !(typeof value === "number" && isNaN(value))
        ) {
          expanded.push([key, value]);
        }
      }
      return expanded;
    };

    const queryString = new URLSearchParams(
      expandArrayParams(params)
    ).toString();

    const apiUrl = `/api/Site/getAllSiteVisits?${queryString}`;
    setLoading(true);
    httpService
      .get(
        apiUrl,
        (res) => {
          setApprovedSiteVisitCards(res.data);
          setPaginationForApproval({
            pageSize: res.metaData.pageSize,
            pageNumber: res.metaData.pageNumber,
            total: res.metaData.totalItemCount,
          });
        },
        (error) => {
          // console.log(error);
        }
      )
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchApprovedSiteVisits();
  }, [
    paginationForApproval.pageNumber,
    paginationForApproval.pageSize,
    debouncedQueryForApproval,
  ]);

  const handleTogglePreviewModal = (record) => {
    const siteVisitCardId = record?.key;
    setSelectedSiteVisit(siteVisitCardId);
    setShowPreviewModal(!showPreviewModal);
  };

  const columnsApproved = [
    {
      title: <span className="styledTitle text-nowrap">Approval Status</span>,
      dataIndex: "approvalStatus",
      key: "approvalStatus",
      render: () => {
        return (
          <div className="fieldReportWriting">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8px"
              height="8px"
              viewBox="0 0 9 9"
            >
              <circle cx="4.5" cy="4.27344" r="4" fill="#3D9B4C" />
            </svg>
            <span>Approved</span>
          </div>
        );
      },
    },
    {
      title: <span className="styledTitle">Site Visit Identifier</span>,
      sorter: (a, b) =>
        a.siteVisitIdentifier.localeCompare(b.siteVisitIdentifier),
      dataIndex: "siteVisitIdentifier",
      key: "siteVisitIdentifier",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Site Visit Name</span>,
      sorter: (a, b) => a.name.localeCompare(b.name),
      dataIndex: "name",
      key: "name",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Facility</span>,
      dataIndex: "facility",
      key: "facility",
      width: 250,
      sorter: (a, b) =>
        (a.facility?.name || "").localeCompare(b.facility?.name || ""),
      render: (facility) => <FacilityTag facility={facility} />,
    },
    {
      title: <span className="styledTitle">Location</span>,
      sorter: (a, b) =>
        a.locationDetails?.country.localeCompare(b.locationDetails?.country),
      key: "location",
      dataIndex: "location",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: (
        <span className="styledTitle" style={{ textWrap: "nowrap" }}>
          Governate/State
        </span>
      ),
      dataIndex: "state",
      key: "state",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Actual Dates of Visit</span>,
      sorter: (a, b) => {
        const aDate = a.actualDateOfVisit?.[0] || "";
        const bDate = b.actualDateOfVisit?.[0] || "";
        return aDate.localeCompare(bDate);
      },
      dataIndex: "actualDateOfVisit",
      key: "actualDateOfVisit",
      render: (data) =>
        data?.length ? (
          data?.map((date) => (
            <span
              className="styledDataIndex3"
              style={{ display: "block" }}
              key={date.id}
            >
              {date}
            </span>
          ))
        ) : (
          <span className="styledDataIndex3">
            No actual date of visit available
          </span>
        ),
    },
    {
      title: <span className="styledTitle">IP</span>,
      sorter: (a, b) => a.ip.localeCompare(b.ip),
      dataIndex: "ip",
      key: "ip",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Cluster</span>,
      sorter: (a, b) => a.cluster.localeCompare(b.cluster),
      dataIndex: "cluster",
      key: "cluster",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Virtual</span>,
      sorter: (a, b) => a.virtual.localeCompare(b.virtual),
      dataIndex: "virtual",
      key: "virtual",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Resources</span>,
      sorter: (a, b) =>
        a.resources?.join("").localeCompare(b.resources?.join("")),
      dataIndex: "resources",
      key: "resources",
      render: (resources) => {
        return (
          <div className="resourcesColumn">
            {resources?.map((file, index) => (
              <span
                onClick={(e) => previewFiles(e, file.fileKey, file.id)}
                key={index}
              >
                {file?.fileName}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      title: <span className="styledTitle"></span>,
      key: "action",
      width: 120,
      fixed:
        isLargeScreen && approvedSiteVisitCards.length > 0
          ? "right"
          : undefined,
      render: (text, record) => (
        <div className="actionDiv">
          <img
            src={previewIcon}
            onClick={() => handleTogglePreviewModal(record)}
            style={{ cursor: "pointer" }}
          />
          <Tooltip title="Mark as complete">
            <img
              src={markAsCompletedIcon}
              alt="complete"
              style={{ cursor: "pointer" }}
              onClick={() => handleCompleteSiteVisit(record?.key)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleCompleteSiteVisit = (siteVisitId) => {
    if (siteVisitId) {
      setLoading(true);
      httpService.put(
        `/api/Site/changeSiteVisitStatus?SiteVisitId=${siteVisitId}&SiteVisitStatus=6`,
        "",
        (response) => {
          setMessage({
            trigger: true,
            type: "success",
            icon: Done,
            title: "Status updated successfully!",
            text: "Site visit status was correctly updated to your database.",
          });
          setTimeout(() => {
            setMessage({
              trigger: false,
            });
          }, 300);
          fetchApprovedSiteVisits();
          setLoading(false);
        },
        (error) => {
          const errorMessage =
            error?.errors?.[0]?.message ||
            error?.message ||
            "We had a problem updating site visit card, please try again.";
          setMessage({
            trigger: true,
            type: "danger",
            icon: exclamationMark,
            title: "Oops! A problem has occurred!",
            text: errorMessage,
          });
          setTimeout(() => {
            setMessage({
              trigger: false,
            });
          }, 300);
          setLoading(false);
        }
      );
    }
  };

  const formatData = (siteVisitCard) => {
    return {
      key: siteVisitCard?.id,
      siteVisitIdentifier: siteVisitCard?.identifier,
      name: siteVisitCard?.name || "N/A",
      actualDateOfVisit: siteVisitCard?.tracking?.siteTrackingVisitDates.map(
        (date) => formatDate(date?.visitDate)
      ),
      ip: siteVisitCard?.ipPlan?.implementingPartner?.name,
      location: siteVisitCard?.locationDetails?.country,
      state:
        siteVisitCard?.locationDetails?.state || "This country has no states.",
      cluster: siteVisitCard?.cluster?.name,
      virtual: siteVisitCard?.isVirtual ? "Yes" : "No",
      resources: siteVisitCard?.siteVisitFiles.filter((item) =>
        [1, 3, 4, 5].includes(item.fileCategory)
      ),

      reportingYear: siteVisitCard?.tracking?.reportingYear,
      reportingMonth: siteVisitCard?.tracking?.reportingMonth,
      trainingDate: siteVisitCard?.tracking?.trainingDate,
      trainingScoreInfo: siteVisitCard?.tracking?.trainingScoreInfo,
      dateOfReport: siteVisitCard?.tracking?.dateOfReport,
      dateOfDebrief: siteVisitCard?.tracking?.dateOfDebrief,
      percentageOfDataCollectionCompleted:
        siteVisitCard?.tracking?.percentageOfDataCollectionCompleted,
      fieldTeamReportingStatus:
        siteVisitCard?.tracking?.fieldTeamReportingStatus,
      trainingIsCompleted: siteVisitCard?.tracking?.trainingIsCompleted,
    };
  };
  const formattedApprovedData = approvedSiteVisitCards?.map(formatData);

  const {
    columns: visibleColumns,
    columnsBar,
    components: tableComponents,
  } = useSiteVisitColumns({
    tableId: "approvedSiteVisits",
    columns: columnsApproved,
    defaultKeys: REPORTING_DEFAULT_COLUMNS,
  });

  const onPageChange = (page, pageSize) => {
    setPaginationForApproval({
      ...paginationForApproval,
      pageNumber: page,
      pageSize: pageSize,
    });
  };

  return (
    <>
      <div className="flagsPage mb-4">
        <span className="tableViewHeaderText">Approved Site Visits</span>
      </div>
      <div className="filtersWrapper">
        <div className="containerFilters">
          <Input
            onChange={handleSearchForApproval}
            placeholder="Search... "
            suffix={<img src={SearchIcon} alt="Search" />}
          />
        </div>
      </div>
      <div
        className="w-100 my-3 d-flex justify-content-start gap-2"
        style={{
          color: "var(--2, #AA1A5F)",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "24px",
        }}
      >
        {loading ? (
          <Spin className="me-2" size="small" spinning={loading} />
        ) : (
          `Total: ${formattedApprovedData?.length || 0} visits`
        )}
        {columnsBar && <span className="ms-auto">{columnsBar}</span>}
      </div>
      <Table
        components={tableComponents}
        rowKey="id"
        dataSource={formattedApprovedData}
        columns={formattedApprovedData?.length > 0 ? visibleColumns : []}
        loading={loading}
        className="tableTPM"
        pagination={{
          ...paginationForApproval,
          onChange: onPageChange,
        }}
        // Sideways scroll, so resizing a column can never push the ones after
        // it off the edge with no way to reach them.
        scroll={{ x: "max-content" }}
      />
      <Preview
        onClose={handleTogglePreviewModal}
        visible={showPreviewModal}
        siteVisitCardId={selectedSiteVisit}
      />
    </>
  );
};

export default Approved;
